import React, { useState } from 'react';
import PropTypes from 'prop-types';

import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';

import AccordionHeader from '../../../../ui/accordion/AccordionHeader';
import AccordionIcon from '../../../../ui/accordion/AccordionIcon';
import InWorkSupport from '../inWorkSupport/InWorkSupport';

import OwnPlacement from './OwnPlacement';
import RecruitmentPlacement from './RecruitmentPlacement';

import app from '../../../../../app.module.css';
import local from '../../submissionStyles/placement.module.css';

const Placement = ({ placementRow }) => {
    // LOCAL STATE
    const [expanded, setExpanded] = useState('');

    const onAccordionChange = (panel) =>
        setExpanded(expanded === panel ? `${expanded}-close` : panel);
    return (
        <div>
            <Accordion
                expanded={expanded === 'workSupport'}
                onChange={() => onAccordionChange('workSupport')}
                className={app.accordionDivider}
                data-testid="iws-accordion"
                slotProps={{ transition: { mountOnEnter: true } }}>
                <AccordionSummary
                    expandIcon={<AccordionIcon />}
                    aria-controls={`panel1a-content`}
                    id={`panel1a-header`}>
                    <AccordionHeader>
                        <div className={local.accordionTitle}>In Work Support</div>
                    </AccordionHeader>
                </AccordionSummary>
                <AccordionDetails>
                    <InWorkSupport placementRow={placementRow} />
                </AccordionDetails>
            </Accordion>

            <Accordion
                expanded={expanded === 'placementInfo'}
                onChange={() => onAccordionChange('placementInfo')}
                className={app.accordionDivider}
                data-testid="placement-info-accordion"
                slotProps={{ transition: { mountOnEnter: true } }}>
                <AccordionSummary
                    expandIcon={<AccordionIcon />}
                    aria-controls={`panel1a-content`}
                    id={`panel1a-header`}>
                    <AccordionHeader>Placement Information</AccordionHeader>
                </AccordionSummary>
                <AccordionDetails>
                    {placementRow.code.slice(0, 2) === 'RP' ? (
                        <RecruitmentPlacement row={placementRow} expanded={expanded} />
                    ) : (
                        <OwnPlacement row={placementRow} expanded={expanded} />
                    )}
                </AccordionDetails>
            </Accordion>
        </div>
    );
};

Placement.propTypes = {
    placementRow: PropTypes.object
};

export default Placement;
